import fancybox from './modules/fancybox.js';

class QuickAdd extends HTMLElement {
  constructor() {
    super();

    this.parentCard = this.closest('[data-product-card]');

    // listen for click on the button, for keyboards
    this.querySelector('[type="submit"]').addEventListener('click', (event) => {
      // only prevent default when the fancybox is opened, otherwise the form can be submitted
      if (this.fancyboxObj) {
        event.preventDefault();
        this.onOptionSelect();
      }
    });

    this.querySelector('[data-quick-shop-toggle]')?.addEventListener('click', (event) => {
      event.currentTarget.classList.add('loading');
      event.currentTarget.setAttribute('disabled', true);
      this.trigger = event.currentTarget;

      setTimeout(() => {
        this.trigger.classList.remove('loading');
        this.trigger.removeAttribute('disabled');
      }, 250);

      this.fancybox();
    });
  }

  /**
   * onOptionSelect
   * @description Adds the clicked option/variant to the cart leveraging the product form component. Adds a variant to the cart.
   */
  onOptionSelect(option = null) {
    if (!this.fancyboxObj) return;

    const productForm = this.fancyboxObj.container.querySelector('product-form-component');
    if (!productForm) return;

    const hiddenId = productForm.querySelector('input[name="id"]');
    if (!hiddenId) return;

    const activeOption = option || Array.from(this.fancyboxObj.container.querySelector('[data-quick-shop-options-wrapper]').querySelectorAll('[data-quick-shop-option]')).filter(input => input.checked === true)[0];
    const errorMessage = productForm.querySelector('[data-form-error]');

    if (!activeOption) {
      errorMessage.classList.add('block');
      return;
    }

    hiddenId.value = activeOption.value;
    const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');
    if (hiddenInventoryQty) hiddenInventoryQty.value = activeOption.dataset.inventoryQuantity;

    // submit the form
    productForm.onSubmitHandler(null, this.trigger);

    // close the fancybox
    setTimeout(() => {
      this.fancyboxObj.close();
    }, 250);
  }

  fancybox() {
    if (!fancybox) return false;

    fancybox.show([ {
      src: this.trigger.dataset.src,
      type: 'inline',
    } ],
    {
      dragToClose: false,
      animated: false,
      on: {
        done: (fancybox) => {
          this.fancyboxObj = fancybox;

          // Add the event listener for the options
          fancybox.container.querySelectorAll('[data-quick-shop-option]').forEach((option) => {
            option.nextElementSibling.addEventListener('click', (event) => {
              const label = event.target.closest('label');
              this.onOptionSelect(label.previousElementSibling);
            });
          });
        },
      },
    },
    );
  }
}

if (!customElements.get('quick-shop')) {
  customElements.define('quick-shop', QuickAdd);
}
